/**
 * Path of E12, the Channels tab (S9 R15). Home links to it (`homeLinks.channels`), `TABS` lists
 * it, and E7 returns to it after a stop (`AFTER_STOP_PATH`); `AppRoutes.test.tsx` keeps the four
 * equal (S9 AC17).
 */
export const CHANNELS_ROUTE = '/channels';
